"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export type NavItem = { href: string; label: string };

// 主選單連結:目前所在頁面會以淺綠色底標示。
export default function NavLinks({ items }: { items: NavItem[] }) {
  const pathname = usePathname();

  return (
    <>
      {items.map((n) => {
        // 目前頁面:完全相同,或是該路徑的子頁(避免 /richmenu 誤判 /richmenu-segments)。
        const active = pathname === n.href || pathname.startsWith(`${n.href}/`);
        return (
          <Link
            key={n.href}
            href={n.href}
            aria-current={active ? "page" : undefined}
            className={`block rounded-lg px-3 py-2 text-sm ${
              active
                ? "bg-emerald-100 font-medium text-emerald-700"
                : "text-gray-700 hover:bg-emerald-50 hover:text-emerald-700"
            }`}
          >
            {n.label}
          </Link>
        );
      })}
    </>
  );
}
